export const EMAIL_CONFIG = {
// Email notification settings
  // Note: actual on/off is controlled by REACT_APP_ENABLE_EMAIL_NOTIFICATIONS env var
  ENABLE_EMAIL_NOTIFICATIONS: true,

  // Email templates - synchronized with backend EmailTemplateService
  TEMPLATES: {
    EVENT_CREATION: 'event-OpenRegistration',  // Maps to backend template
    EVENT_UPDATE: 'event-update',
    EVENT_REMINDER: 'event-reminder',
    EVENT_CANCELLATION: 'event-cancellation',
    TASK_CREATION: 'task-creation',            // Maps to backend template
    TASK_REMINDER: 'task-reminder'             // Maps to backend template (manual send)
  },

  // Email subjects - Note: Backend now controls actual subjects via templates
  // These are used for frontend display/logging purposes only
  SUBJECTS: {
    EVENT_CREATED: (eventTitle: string) => `‼️Register Now‼️ - ${eventTitle}`,  // Matches backend
    EVENT_UPDATED: (eventTitle: string) => `Event Updated - ${eventTitle}`,
    EVENT_REMINDER: (eventTitle: string) => `Event Reminder - ${eventTitle}`,
    EVENT_CANCELLED: (eventTitle: string) => `Event Cancelled - ${eventTitle}`,
    TASK_CREATED: (taskTitle: string) => `📋 New Task Assigned - ${taskTitle}`,
    TASK_REMINDER: () => `🔔 Task Reminder`
  },

  // Default values - synchronized with backend
  DEFAULTS: {
    FROM_NAME: 'Engagement App',  // Matches backend EmailTemplateService
    REPLY_TO: 'engagementappti@telusinternational.com'  // Matches backend
  },

  // Template metadata for frontend reference
  TEMPLATE_INFO: {
    'event-OpenRegistration': {
      displayName: 'Event Registration',
      description: 'Sent when event registration opens',
      icon: '🎉',
      color: '#667eea'
    },
    'event-update': {
      displayName: 'Event Update',
      description: 'Sent when event details are updated',
      icon: '📝',
      color: '#f5576c'
    },
    'event-reminder': {
      displayName: 'Event Reminder',
      description: 'Sent as event reminder',
      icon: '⏰',
      color: '#4facfe'
    },
    'event-cancellation': {
      displayName: 'Event Cancellation',
      description: 'Sent when event is cancelled',
      icon: '❌',
      color: '#ff6b6b'
    }
  }
}

export const isEmailNotificationEnabled = (): boolean => {
  // Allow the env var to override the default flag.
  // REACT_APP_ENABLE_EMAIL_NOTIFICATIONS=true  → emails enabled
  // REACT_APP_ENABLE_EMAIL_NOTIFICATIONS=false → emails disabled
  // If the env var is not set, fall back to the static flag.
  if (process.env.REACT_APP_ENABLE_EMAIL_NOTIFICATIONS !== undefined) {
    return process.env.REACT_APP_ENABLE_EMAIL_NOTIFICATIONS === 'true'
  }
  return EMAIL_CONFIG.ENABLE_EMAIL_NOTIFICATIONS
}

/**
 * Controls whether email notifications are sent to all event invitees.
 *
 * Controlled by the REACT_APP_NOTIFY_INVITEES environment variable:
 *   - false (development, testing): emails go only to the event creator
 *   - true  (staging, production):  emails go to the creator + all invited team members
 *
 * This prevents accidental emails to real users during development/testing.
 */
export const isNotifyInviteesEnabled = (): boolean => {
  return process.env.REACT_APP_NOTIFY_INVITEES === 'true'
}
